<template>
  <span class="phone-wrapper">
    <the-mask
      type="text"
      v-model="value"
      mask="+1 (###) ###-####"
      class="phone-input"
    />
    <input type="hidden" :name="name" :value="value">
  </span>
</template>

<script>
import {TheMask} from 'vue-the-mask'
export default {
    components: {
        TheMask
    },
    props: {
        name: {
            type: String,
            default: 'phone'
        },
        initialValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
          value: null
        }
    },
    mounted() {
      this.value = this.initialValue
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/PhoneField.vue